/**
 * Public-demo analytics events (Patch 34.1.10).
 *
 * Fire-and-forget instrumentation for the competition landing +
 * dual-demo journey. Never includes workspace IDs, user IDs, or
 * internal metadata — only the event name, source route, and device
 * class. Pushes to ``window.dataLayer`` when present (any GA/GTM
 * script) and logs to the console in preview builds for QA.
 */
export type DemoAnalyticsEvent =
  | "contest_landing_viewed"
  | "seeded_demo_opened"
  | "brain_builder_demo_opened"
  | "demo_switched"
  | "demo_signin_clicked"
  | "demo_build_my_own_clicked";

function deviceClass(): "mobile" | "tablet" | "desktop" {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export function trackDemoEvent(event: DemoAnalyticsEvent, source_route?: string): void {
  if (typeof window === "undefined") return;
  const payload = {
    event,
    source_route: source_route ?? window.location.pathname,
    device_class: deviceClass(),
    ts: new Date().toISOString(),
  };
  // GTM / GA4 style push — safe no-op when absent.
  const dl = (window as unknown as { dataLayer?: unknown[] }).dataLayer;
  if (Array.isArray(dl)) dl.push(payload);
  if (import.meta.env.DEV) {
    console.debug("[demo-analytics]", payload);
  }
}
